import { http, HttpResponse } from 'msw';

const mockTracking = [
  http.post(`${process.env.API_GATEWAY_BASE_URI}tracking/tracking`, () => HttpResponse.json(null, { status: 200 })),
];
export { mockTracking };
